import { render, staticRenderFns } from "./EditorComponentSection.vue?vue&type=template&id=022983f4&"
import script from "./EditorComponentSection.vue?vue&type=script&lang=js&"
export * from "./EditorComponentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports